const initialState = {};

const initialStateForTest = {};

export default initialState;
export { initialStateForTest };
